// 业务场景
export const SCENE_TYPE = {
  TWO_WHEEL: 't_tw_card_active', // 俩轮哈口令复制
  STUDENT_CENTER: 't_from_student_center', // 学生中心跳转哈口令复制
  SWAP_BATTERY: 't_from_swap_battery',
};

// adsource，默认无就是俩轮
export const ADSOURCE_TYPE = {
  STUDENT_CENTER: 'student', // 学生中心跳转哈口令复制
  SWAP_BATTERY: 'swapHa',
};

// 页面图片配置scene
export const PAGE_INFO_SCENE = {
  [SCENE_TYPE.TWO_WHEEL]: 'bicycle',
  [SCENE_TYPE.STUDENT_CENTER]: 'student',
  [SCENE_TYPE.SWAP_BATTERY]: 't_from_swap_battery',
};

export const [PAGE_INFO_BIZ_BIKE, PAGE_INFO_BIZ_EBIKE] = [1, 2]; // 业务参数，1单车 2助力车

// 活动领奖接口eventCode
export const EVENT_CODE = {
  SWAP_BATTERY: 'tiktok_battery',
};

// 不同环境的子场景配置
// 子场景获取参考文档：https://hellobike.yuque.com/wx01fq/newbie/al6yk24ztbvzt782?singleDoc#
export const SUB_SCENE_MAP = {
  // 两轮场景配置
  TWO_WHEEL: {
    fat: '10',
    uat: '4',
    pro: '5',
  },
  // 学生中心场景配置
  STUDENT_CENTER: {
    fat: '11',
    uat: '5',
    pro: '7',
  },
  // 小哈换电场景配置
  SWAP_BATTERY: {
    fat: '13',
    uat: '6',
    pro: '8',
  },
};

// 领奖状态码1：可领 2:已领 3:已抢光 4: 已过期 5: 已使用 6:风控拦截 7:作废
export const PRIZE_STATUS = {
  CAN_RECEIVE: 1,
  ALREADY_RECEIVED: 2,
  ALREADY_SOLD_OUT: 3,
  EXPIRED: 4,
  USED: 5,
  RISK_CONTROL: 6,
  INVALID: 7,
};

export default {
  SCENE_TYPE,
  ADSOURCE_TYPE,
  PAGE_INFO_SCENE,
  PAGE_INFO_BIZ_BIKE,
  PAGE_INFO_BIZ_EBIKE,
  SUB_SCENE_MAP,
};
